// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"608ff46b","453":"670e15c7","796":"7aafc391"}[chunkId] + ".chunk.js";
};